import DistributionBannerContainer from './DistributionBannerContainer'

export default DistributionBannerContainer
